export default "__VITE_ASSET__B_8Tkb5H__"